import {Component, OnInit} from '@angular/core';
import {WizardListPageBaseComponent} from '@utils-lib';
import {OrganschaftAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'common-ui-organschaft-angaben',
    templateUrl: './organschaft-angaben.component.html',
    styleUrls: ['./organschaft-angaben.component.scss']
})
export class OrganschaftAngabenComponent extends WizardListPageBaseComponent<OrganschaftAngaben> implements OnInit {

    static nutzdatenPath = 'organschaftAngaben';
    static route = 'organschaft-angaben';

    constructor(protected readonly activatedRoute: ActivatedRoute,
                private readonly translateService: TranslateService) {
        super(activatedRoute);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        if (!this.data.organgesellschaften) {
            this.data.organgesellschaften = [];
        }
    }

    public addOrgangesellschaft(): void {
        this.data.organgesellschaften.push({
            bezeichnung: this.translateService.instant('COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.NEUE_ORGANSCHAFT')
        });
        this.selectedIndex = this.data.organgesellschaften.length - 1;
    }

    public removeOrgangesellschaft(index: number): void {
        this.data.organgesellschaften.splice(index, 1);
    }

    protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
        return new Map<string, unknown | Array<unknown>>([]);
    }
}
